import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {ExerciseId} from '../../domain/exercise-id.value-object';

export class ExerciseIdValidator implements Validator<ExerciseId> {
  readonly standardSchema = z.templateLiteral(['exr', '_', z.string().min(1)]);

  validate(value: unknown): Result<ExerciseId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid exercise id.'),
      );
    }
    return ok(parsed.data);
  }
}
